import { render, staticRenderFns } from "./GuidelinePreviousVersionsHeader.vue?vue&type=template&id=63401400&scoped=true&"
var script = {}
import style0 from "./GuidelinePreviousVersionsHeader.vue?vue&type=style&index=0&id=63401400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63401400",
  null
  
)

export default component.exports